import { Box, Text } from '@cmpsr/components';
import useIsMobile from '../../../../../../../hooks/use-is-mobile';
import { text } from '../../../common/theme';

interface RiskPercentageProps {
  riskScore?: number;
}

const RiskPercentage = ({ riskScore = 46 }: RiskPercentageProps) => {
  const isMobile = useIsMobile();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap="spacer-4" width={{ base: '100%', lg: '100%' }}>
      <Text as="h1" color="white" textAlign="center" {...text.mobile.h2.primary}>
        Your estimated cancer
        {isMobile && <br />} risk is{' '}
        <Box as="span" color="salmon-light" {...text.mobile.h2.accent}>
          {riskScore}%
        </Box>
      </Text>
    </Box>
  );
};

export default RiskPercentage;
